import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { Link } from 'react-router';

import { Verbs } from '../../constants/LRSConstants';

import { Card, CardMedia, CardText, CardTitle } from 'material-ui/Card';
import AssetSegment from '../Asset/AssetSegment';
import CpdSegment from '../Module/CpdSegment';
import TrainerSegment from '../Module/TrainerSegment';
import CourseContentMain from './CourseContentMain';
import EnrolmentSegment from './EnrolmentSegment';
import ModuleSegment from './ModuleSegment';
import Dialog from 'material-ui/Dialog';

import DetailView from '../Common/DetailView';
import RaisedButton from 'material-ui/RaisedButton';

import { LauncherButton } from '../Elearning/Launcher';
import LinearProgress from 'material-ui/LinearProgress';
import { DateStyles } from '../../constants/CentricConstants';
import Snackbar from 'material-ui/Snackbar';
// Icons
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import TimeLineIcon from 'material-ui/svg-icons/action/timeline';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import EventIcon from 'material-ui/svg-icons/action/event';
import TrainerIcon from 'material-ui/svg-icons/social/school';
// business logic
import CourseStore from '../../stores/CourseStore';
import CourseAssetStore from '../../stores/CourseAssetStore';
import CourseEnrolmentStore from '../../stores/CourseEnrolmentStore';
import CourseModuleStore from '../../stores/CourseModuleStore';
import CourseTrainerStore from '../../stores/CourseTrainerStore';
import ModuleEventStore from '../../stores/ModuleEventStore';
import EventAttendeeStore from '../../stores/EventAttendeeStore';
import CourseActions from '../../actions/CourseActionCreator';
import EventActions from '../../actions/EventActionCreator';
import LRS from '../../utils/LRS';
// wow, modules linked in...
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleSubscriptionStore from '../../stores/ModuleSubscriptionStore';
import MessageStore from '../../stores/MessageStore';
import { removeLastMessage } from '../../actions/MessageActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import ElearningPlayerDialog from '../Elearning/ElearningPlayerDialog';
import { withId } from '../Common/Decorators';
import RetakeCourseDialog from './RetakeCourseDialog';
import DialogActions from '../../actions/DialogActionCreator';
import { CourseDialogs } from '../../constants/Dialogs';

const getMenuItems = ({id}, moduleId = null) => [
    {
        link: `/dashboard/course/${id}/enrolments`,
        icon: <EnrolmentIcon />,
        label: 'Enrolments',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/module/${moduleId}/activity`,
        icon: <TimeLineIcon />,
        label: 'Activity',
        condition: {
            roles: [ROLES.MANAGER, ROLES.ADMIN],
            show: !!moduleId
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/course/${id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'divider'
    },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    }
];

const Course = React.createClass({

    getInitialState: function(){
        return {
            open: false,
            searchText: '',
            showMessage: false,
            showCompletionDialog: false,
            message: '',
            details: {
                name: '',
                description: '',
                theme: '',
                image: '',
                overview: '',
                duration: null,
                cost: '',
                price: '',
                url: '',
                type: '',
                status: '',
                code: '',
                capacity: '',
                version: '',
                visibility: '',
                validFrom: '',
                skillId: null,
                skillName: '',
                skillCode: '',
                skillLevel: '',
                emailTemplate: '',
                designatedModuleId: null
            },
            modules: [],
            assets: [],
            trainers: [],
            courseEnrolment: {
                id: '',
                status: '',
                method: '',
                type: '',
                hash: '',
                dateCommenced: '',
                dateCompleted: '',
                dateStart: '',
                requirement: '',
                progress: '',
                score: '',
            },
            isFetchingEnrolment: false,
            isFetchingSubscription: false,
            enrolmentActions: [],
            activity: {},
            subscription: {},
            nextEvent: null,
            attendingNextEvent: false,
            links: {
                back: '/dashboard/library',
                edit: '',
            }
        };
    },

    componentDidMount: function(){
        this.listeners = [
            CourseTrainerStore.addListener(this._onTrainerChange),
            ModuleSubscriptionStore.addListener(this.onSubscriptionChange),
            ModuleEventStore.addListener(this.onModuleEventChange),
            EventAttendeeStore.addListener(this.checkAttendance),
            MessageStore.addListener(this.onCheckCompletion),
            CourseModuleStore.addListener(this._onCourseModulesChange),
            CourseStore.addListener(this._onCourseChange),
            CourseAssetStore.addListener(this.onAssetChange),
            CourseEnrolmentStore.addListener(this._onCourseEnrolmentChange),
        ];

        CourseActions.getById(this.props.id);
        CourseActions.getModules(this.props.id);

        CourseActions.getAssets(this.props.id);
        CourseActions.getTrainers(this.props.id);

        CourseActions.getMyEnrolment(this.props.id);

        this.setState({
            actions: buildContextMenu(getMenuItems(this.props), this.context.auth),
        });
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
    },

    render: function() {

        let actions = this.state.actions;
        let nextEvent;

        let designatedModule;
        if (!!this.state.details.designatedModuleId && this.state.modules.length > 0) {
            designatedModule = this.state.modules.find((m) => m !== undefined && m.id === this.state.details.designatedModuleId);
            actions = getMenuItems(this.props, this.state.details.designatedModuleId).slice(0);
            if (!!designatedModule && designatedModule.type === 'classroom') {
                actions.unshift(
                    {
                        link: `/dashboard/module/${this.state.details.designatedModuleId}/events`,
                        icon: <EventIcon/>,
                        label: 'Events',
                    },
                    {
                        link: `/dashboard/module/${this.state.details.designatedModuleId}/calendar`,
                        icon: <EventIcon/>,
                        label: 'Calendar',
                    },
                    {
                        type: 'divider'
                    },
                    {
                        link: `/dashboard/module/${this.state.details.designatedModuleId}/trainers`,
                        icon: <TrainerIcon/>,
                        label: 'Trainers',
                    }
                );

                if (!!this.state.nextEvent) {
                    const start = new Date(this.state.nextEvent.timeStart);
                    const end = new Date(this.state.nextEvent.timeEnd);
                    const startLabel = start.toLocaleString('en-GB', DateStyles.shortDateTime);
                    const endLabel = start.toDateString() !== end.toDateString() ? end.toLocaleString('en-GB', DateStyles.shortDateTime) : end.toLocaleTimeString('en-GB').substr(0, 5);
                    const attending = this.state.attendingNextEvent ? ' - Attending' : '';
                    nextEvent = (
                        <CardText>
                            Upcoming event:
                            <Link to={`/dashboard/event/${this.state.nextEvent.id}`}> {startLabel} - {endLabel}</Link>{attending}
                        </CardText>
                    );
                }
            }
            actions = buildContextMenu(actions, this.context.auth);
        }

        let mainContentData = {
            course:             this.state.details,
            assets:             this.state.assets,
            required:           !!designatedModule ? designatedModule.required : null
        };

        const CpdData = {
            cpdCredits:     Number(this.calculateTotal('cpdCredits')),
            skillId:        this.state.details.skillId,
            skillName:      this.state.details.skillName,
            skillCode:      this.state.details.skillCode,
            skillLevel:     this.state.details.skillLevel,
            passMark:       this.state.details.requirement,
        };

        let enrolmentData = {
            course:             this.state.details,
            enrolment:          this.state.courseEnrolment,
            modules:            this.state.modules
        };

        if (!!this.state.details.designatedModuleId) {
            enrolmentData.subscription = this.state.subscription;
        }


        let segmentModule;
        if (!!this.state.modules && this.state.modules.length > 0 && !!this.state.details.id) {
            if (this.state.modules.length > 1 || !this.state.details.designatedModuleId) {
                const moduleData = {
                    courseId:           this.props.id,
                    modules:            this.state.modules,
                    link:               `/dashboard/course/${this.props.id}/module/{moduleId}`,
                    userId:             this.context.auth.identity.id,
                    designatedModuleId: this.state.details.designatedModuleId
                };
                segmentModule = (<ModuleSegment {...moduleData} />);
            }
        }

        let enrolmentActions = [];

        if (this.state.details.status === 'active') {

            if (!!this.state.details.designatedModuleId && !!this.state.subscription.status) {
                const module = designatedModule || { type: this.state.details.type };
                // if there's a designated module, let's take over its buttons
                switch (module.type) {
                    case 'e-learning':
                        const data = {
                            ...this.state.subscription,
                            isAssigned: ((this.state.subscription && this.state.subscription.isAssigned) || (this.state.courseEnrolment && this.state.courseEnrolment.isAssigned))
                        };
                        enrolmentActions.push(
                            <LauncherButton
                                key="btn_launch"
                                data={data}
                                courseId={this.props.id}
                                designated={true}
                                asPopup={!!module.launchAsPopup}
                            />
                        );
                        break;

                    case 'resource':
                        mainContentData.designatedModule = module;
                        if (!!this.state.moduleEnrolment.status && this.state.moduleEnrolment.status !== 'completed') {
                            enrolmentActions.push(
                                <RaisedButton
                                    className="button-raised"
                                    key="btn_complete"
                                    label="Complete"
                                    primary={true}
                                    fullWidth={true}
                                    onTouchTap={this.handleComplete}
                                />
                            );
                        }
                        break;
                    case 'video':
                    case 'audio':
                        mainContentData.mediaId = module.mediaId;
                        mainContentData.mediaContent = module.mediaContent;
                        break;

                    default:
                        break;
                }
            }

            switch (this.state.courseEnrolment.status) {

                case 'loading':
                    enrolmentActions.push( <LinearProgress mode="indeterminate" key="loading" />);
                break;

                case 'waiting':
                    if (this.state.courseEnrolment.method === 'booked') {
                        enrolmentActions.push(
                            <RaisedButton
                                className="button-raised"
                                key="btn_cancel"
                                label="Cancel"
                                fullWidth={true}
                                onTouchTap={this.handleCancelUser}
                            />
                        );
                    }
                    break;

                case 'enrolled':
                    if (this.state.courseEnrolment.method === 'booked') {
                        enrolmentActions.push(
                            <RaisedButton
                                className="button-raised"
                                key="btn_unenrol"
                                label="Unenrol"
                                fullWidth={true}
                                onTouchTap={this.handleCancelUser}
                            />
                        );
                    }
                    if (!!this.state.details.designatedModuleId && !!this.state.subscription.status && this.state.subscription.status === 'completed') {
                        if (this.state.courseEnrolment.canRetake || this.state.details.visibility === 'public') {
                            enrolmentActions.push(
                                <RaisedButton
                                    className="button-raised"
                                    key="btn_retake_module"
                                    label="Retake Module"
                                    fullWidth={true}
                                    onTouchTap={this.handleRetakeDesignatedModule}
                                    secondary
                                />
                            );
                        }
                    }
                    break;

                case 'completed':
                    if (this.state.courseEnrolment.canRetake || this.state.details.visibility === 'public') {
                        enrolmentActions.push(
                            <RaisedButton
                                className="button-raised"
                                key="btn_retake"
                                label="Retake"
                                fullWidth={true}
                                onTouchTap={this.handleRetake}
                                secondary
                            />
                        );
                    }
                    break;

                case 'cancelled':
                default:
                    if (this.state.details.visibility === 'public') {
                        enrolmentActions.push(
                            <RaisedButton
                                className="button-raised"
                                key="btn_enrol"
                                label="Enrol"
                                primary={true}
                                fullWidth={true}
                                onTouchTap={this.handleEnrolUser}
                            />
                        );
                    }
                    break;
            }
        }

        if (enrolmentActions.length > 0) {
            if (!this.state.isFetchingSubscription && !this.state.isFetchingEnrolment) {
                enrolmentData.actions = enrolmentActions;
            }
        }

        return (

            <DetailView
                backButton={true}
                backTo={`/dashboard/library/${this.state.details.categoryId || 'uncategorised'}`}
                forceBack={!!this.props.location.query.forceBack}
                actions={actions}
            >
                <div className="cent-cards">
                    <div className="cent-flex-column cent-col-8">
                        <Card className="cent-card" key="mainContent">
                            {!this.state.details.image
                                ? <CardTitle title={this.state.details.name} subtitle={this.state.details.code} />
                                : (
                                    <CardMedia
                                        className="cent-card-media"
                                        overlay={<CardTitle title={this.state.details.name} subtitle={this.state.details.code} />}
                                    >
                                        <img src={this.state.details.image} alt="" />
                                    </CardMedia>
                                )
                            }
                            <CardText>
                                <CourseContentMain {...mainContentData} />
                            </CardText>
                        </Card>
                        {segmentModule}
                    </div>
                    <div className="cent-flex-column cent-col-4">
                        <EnrolmentSegment {...enrolmentData} />
                        {<CpdSegment {...CpdData} />}
                        {<TrainerSegment trainers={this.state.trainers} />}
                        {<AssetSegment assets={this.state.assets} />}
                        <Card className="cent-card ">
                            {nextEvent}
                        </Card>
                    </div>
                </div>
                {(!!designatedModule && designatedModule.type === 'e-learning') && (
                    <ElearningPlayerDialog
                        moduleId={designatedModule.id}
                        title={this.state.details.name}
                        onClose={() => ModuleActions.getSubscription(designatedModule.id, this.context.auth.identity.id)}
                    />
                )}
                {(!designatedModule && this.state.modules.length > 0) && (
                    <RetakeCourseDialog
                        modules={this.state.modules}
                    />
                )}
                <Snackbar
                    open={this.state.showMessage}
                    action="OK"
                    message={this.state.message}
                    onActionTouchTap={this.onCloseSnackbar}
                    onRequestClose={this.onCloseSnackbar}
                />
                <Dialog
                    title="Congratulations!"
                    open={this.state.showCompletionDialog}
                    actions={[
                        <RaisedButton
                            label="retry"
                            onTouchTap={() => this.setState({showCompletionDialog: false})}
                        />,
                        <RaisedButton
                            label="finish"
                            secondary
                            onTouchTap={() => {
                                CourseActions.checkCompletion(this.state.courseEnrolment.id);
                                this.setState({showCompletionDialog: false});
                            }}
                        />
                    ]}
                >
                    You have passed this course.<br />
                    Click ‘Retry’ if you want to attempt it again or ‘Finish’ if you are happy with this result.
                </Dialog>
            </DetailView>
        );
    },

    _onCourseChange: function() {
        const details = CourseStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({ details });
            if (!!details.designatedModuleId) {
                ModuleActions.getSubscription(details.designatedModuleId, this.context.auth.identity.id);
                ModuleActions.getEvents(details.designatedModuleId, {limit: 1, sort: 'timeStart', startDate: new Date().toString().replace(/\s\([^)]+\)/, '')});
            }
        }
    },

    _onCourseEnrolmentChange: function() {
        const enrolment = CourseEnrolmentStore.get(this.props.id, this.context.auth.identity.id);
        const isFetchingEnrolment = CourseEnrolmentStore.isFetching();

        if (enrolment !== undefined) {
            const prevStatus = this.state.courseEnrolment.status;
            let courseEnrolment;
            if (enrolment.status === undefined) {
                courseEnrolment = {status: 'none'};
            } else {
                courseEnrolment = {
                    status: enrolment.status,
                    dateStart: enrolment.dateStart,
                    dateCompleted: enrolment.dateCompleted,
                    isAssigned: enrolment.isAssigned,
                    isMandatory: enrolment.isMandatory,
                    method: enrolment.method,
                    requirement: enrolment.requirement,
                    score: enrolment.score,
                    progress: enrolment.progress,
                    type: enrolment.type,
                    hash: (enrolment.status === 'enrolled' || enrolment.status === 'completed' ? (enrolment.hash || '') : '' ),
                    canRetake: !!enrolment.canRetake
                };
                if (enrolment.id !== undefined) { courseEnrolment.id = enrolment.id; }
                if (!!enrolment.skillExpires) { courseEnrolment.skillExpires = enrolment.skillExpires; }
            }
            let state = {courseEnrolment, isFetchingEnrolment};
            if (this.state.details.type === 'e-learning' && !!enrolment.canComplete && enrolment.status === 'enrolled') {
                if (this.state.details.designatedModuleId) {
                    CourseActions.checkCompletion(enrolment.id);
                } else {
                    state.showCompletionDialog = true;
                }
            }
            this.setState(state);
            if (this.state.details.designatedModuleId) {
                if (prevStatus !== courseEnrolment.status && !this.state.isFetchingSubscription) {
                    ModuleActions.getSubscription(this.state.details.designatedModuleId, this.context.auth.identity.id);
                }
            } else {
                // should be moved into its own component
                ModuleActions.getCourseUserSubscriptions(this.props.id, this.context.auth.identity.id);
            }

        } else if (isFetchingEnrolment !== this.state.isFetchingEnrolment) {
            this.setState({isFetchingEnrolment});
        }
    },

    onSubscriptionChange: function() {
        const subscription = ModuleSubscriptionStore.getSubscription(this.state.details.designatedModuleId, this.context.auth.identity.id);
        const isFetchingSubscription = ModuleSubscriptionStore.isFetching();
        if (!!subscription) {
            // on status change
            if (!!this.state.subscription.status && (this.state.subscription.status !== subscription.status || this.state.subscription.success !== subscription.success || this.state.subscription.score !== subscription.score)) {
                // there are changes happening, reload enrolment:
                CourseActions.getMyEnrolment(this.props.id);
            }
            this.setState({subscription, isFetchingSubscription});
        } else if (isFetchingSubscription !== this.state.isFetchingSubscription) {
            this.setState({isFetchingSubscription});
        }
    },

    onAssetChange: function () {
        let assets = CourseAssetStore.getByCourse(this.props.id);
        if (!!assets) {
            this.setState({assets: assets.filter((e) => e !== undefined && e.type !== 'e-learning')});
        }
    },

    _onTrainerChange: function () {
        let trainers = CourseTrainerStore.getByCourse(this.props.id);
        if (trainers !== undefined) {
            let state = assign({}, this.state, {trainers});
            this.setState(state);
        }
    },

    _onCourseModulesChange: function () {
        const modules = CourseModuleStore.getModules(this.props.id);
        if (modules !== undefined) {
            this.setState({modules});
        }
    },

    handleEnrolUser: function() {
        if (this.state.courseEnrolment.status !== 'enrolled') {
            CourseActions.enrollUser(this.props.id, {});
            let state = assign(this.state, {courseEnrolment: {status: 'loading'}});
            this.setState(state);
        }
    },

    handleRetake() {
        if (!this.state.courseEnrolment || !this.state.courseEnrolment.id) { return; }
        if (!!this.state.details.designatedModuleId) {
            // retake
            CourseActions.resetEnrolment(this.props.id, this.state.courseEnrolment.id);
        } else {
            // show retake dialog
            const preselected = this.state.modules.reduce((ac, {id, type}) => ({...ac, [id]: type === 'e-learning'}), {});
            DialogActions.open(CourseDialogs.RETAKE_COURSE, {modules: preselected, courseId: this.props.id, enrolmentId: this.state.courseEnrolment.id});
        }
    },

    handleRetakeDesignatedModule() {
        if (!this.state.details.designatedModuleId) { return; }
        if (!this.state.subscription || !this.state.subscription.moduleId) { return; }
        ModuleActions.resetSubscription(this.state.subscription.moduleId, this.state.subscription.userId, this.state.subscription);
    },

    handleCancelUser: function() {
        if (this.state.courseEnrolment.status !== 'cancelled') {
            CourseActions.updateEnrolment(this.props.id, this.state.courseEnrolment.id, {status: 'cancelled'});
            let state = assign({}, this.state, {subscription: {}});
            this.setState(state);
        }
    },

    handleComplete: function() {
        if (confirm("You confirm that you have completed reading the provided material?")) {
            let user = this.context.auth.getCurrentUser();
            const onSave = function() {
                let originalStatus = this.state.moduleEnrolment.status;
                let enrolment = assign(this.state.moduleEnrolment, {status: 'completed'});
                let state = assign(this.state, {moduleEnrolment: enrolment});
                this.setState(state);
                if (originalStatus !== 'completed') {
                    ModuleActions.saveSubscription(this.state.moduleId, this.context.auth.identity.id, {status: 'completed', score: 100}, this.state.moduleEnrolment);
                }
            }.bind(this);
            let activity = {type: 'document', id: this.props.id};
            LRS.saveCustomStatement(user, Verbs.COMPLETED, activity, onSave);
        }
    },

    onCheckCompletion: function () {
        const message = MessageStore.getLastMessage();
        if (message !== '') {
            this.setState({showMessage: true, message});
        }
    },

    onCloseSnackbar: function () {
        removeLastMessage();
        this.setState({showMessage: false, message: ''});
    },

    onModuleEventChange: function () {
        const nextEvent = ModuleEventStore.getNextEventByModule(Number(this.state.details.designatedModuleId));
        if (!!nextEvent) {
            this.setState({nextEvent});
            EventActions.getAttendance(nextEvent.id, this.context.auth.identity.id);
        }
    },

    checkAttendance: function() {
        if (this.state.details.type === 'classroom' && !!this.state.nextEvent) {
            const attendance = EventAttendeeStore.getDetails(Number(this.state.nextEvent.id), this.context.auth.identity.id);
            if (attendance !== undefined) {
                this.setState({attendingNextEvent: (attendance.status === 'attending')});
            }
        }
    },

    calculateTotal: function(property) {
        return this.state.modules.reduce((current, module) => current + Number(module[property]), 0);
    }

});

Course.contextTypes = {
    auth: PropTypes.object.isRequired
};


export default withId(Course);
